import check from '../../assets/check.png';
import { Milestone } from '../../interfaces/progress';

type Props = {
    item: Milestone
}

const DoneMilestone = ({item}:Props) => {
    return (
        <div className="row">
            <div className="col-sm-3 text-center">
                <img src={check} alt="" width="45" height="auto"/>
            </div>
            <div className="col-sm-9">
                <p className="custom-font"
                style={{color: "#a1a4a5", lineHeight: '1.8em'}}>{item.question}</p>
            </div>
        </div>
    )
}

export default DoneMilestone
